import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { thunk } from 'redux-thunk';
import reducers from './reducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(sagaMiddleware, thunk)));

sagaMiddleware.run(sagas);

// Deliberately unconditional, production included: being able to tell someone
// on the phone to open the console and run `store.getState()` is worth more to a
// two-person team than what it costs, which is nothing. The JWT is in
// localStorage, so anyone who can run JS on this page already holds the token
// and can call the API directly - this exposes no data and no capability that
// was not already theirs.
//
// It used to be wrapped in `if (process.env.MODE !== 'production')`, but only
// worked in production by accident: webpack 4's fake `process` made MODE
// undefined, so the guard was always true. Anyone "fixing" that would have
// silently taken the tool away.
window.store = store;

export default store;
